import { axiosPublic } from "../../api/axios";

const getActiveBanners = async () => {
  const response = await axiosPublic.get("/banners");
  return response.data;
};

const bannerService = {
  getActiveBanners,
};

export default bannerService;
